import { render, staticRenderFns } from "./NewProposal.vue?vue&type=template&id=f001761c&scoped=true"
import script from "./NewProposal.vue?vue&type=script&lang=js"
export * from "./NewProposal.vue?vue&type=script&lang=js"
import style0 from "./NewProposal.vue?vue&type=style&index=0&id=f001761c&prod&lang=scss"
import style1 from "./NewProposal.vue?vue&type=style&index=1&id=f001761c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f001761c",
  null
  
)

export default component.exports